<template>
  <v-dialog v-bind="$attrs" scrollable v-on="$listeners">
    <v-card>
      <v-card-title>店舗選択</v-card-title>
      <v-card-text>
        <v-layout wrap>
          <v-flex v-for="shop in shops" :key="shop.id" xs4 class="pa-3">
            <v-checkbox
              v-model="selectedShopId"
              :value="shop.id"
              color="primary"
              hide-details
              on-icon="mdi-check-circle"
              off-icon="mdi-checkbox-blank-circle-outline"
            >
              <span slot="label">
                {{ shop.name }}
              </span>
            </v-checkbox>
          </v-flex>
        </v-layout>
        <infinite-loading @infinite="infiniteHandler">
          <span slot="no-more" />
        </infinite-loading>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" @click="selectShop">設定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'ShopSelection',
  data: () => ({
    selectedShopId: null,
    shops: [],
    next: null,
  }),
  computed: {
    ...mapGetters({ currentShop: 'shop' }),
  },
  watch: {
    currentShop: {
      immediate: true,
      handler(shop) {
        if (shop) this.selectedShopId = shop.id
      },
    },
  },
  methods: {
    ...mapActions(['setShop']),
    async infiniteHandler($state) {
      try {
        let { results, next } = await (this.next
          ? this.$api.http.get(this.next)
          : this.$api.shops().list())
        this.shops = this.shops.concat(results)
        this.next = next
        if (results.length > 0) $state.loaded()
        if (!next) $state.complete()
      } catch (err) {
        console.error(err)
        $state.error()
      }
    },
    selectShop() {
      let id = this.selectedShopId
      let shop = this.shops.find(x => x.id === id)
      if (shop) {
        this.setShop(shop)
        this.$emit('input', false)
      }
    },
  },
}
</script>

<style></style>
